<div>
    <div>
        <div>
            <p>Unfortunately our registration service is unavailable at the moment, we are working to get this back up
                as quickly as possible and apologize for this inconvenience. </p>
            <p>
                In the meantime should you not have an account with us and wish to order Tests or Supplies please reach
                out to our friendly Client Service Management team. They can be reached on <span><a
                        href="tel:+6478582000">+64 7 858 2000</a></span>
            </p>
        </div>
    </div>
</div>